import { render, staticRenderFns } from "./MagazineAndProgram.vue?vue&type=template&id=14b86630&scoped=true&"
import script from "./MagazineAndProgram.vue?vue&type=script&lang=js&"
export * from "./MagazineAndProgram.vue?vue&type=script&lang=js&"
import style0 from "./MagazineAndProgram.vue?vue&type=style&index=0&id=14b86630&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "14b86630",
  null
  
)

export default component.exports